const base_url = {
  /***** LOCAL DEVELOPMENT ******/
 // base_url: "http://localhost:5000",
//frontendUrl: "http://localhost:3000",
  // customer: "Local",

  /**** DEV URLS ****/
   // base_url: "https://dev.qmentisai.ai/api",
   // frontendUrl: "https://dev.qmentisai.ai",

  /**** DEMO URLS ****/
  // base_url: "https://demo.qmentisai.ai/api",
  // frontendUrl: "https://demo.qmentisai.ai",

  /***** PRODUCTION URLS ******/
   base_url: "https://qmentis.in/api",
   frontendUrl: "https://qmentis.in",

  // /**** Test URLS ****/
   // base_url: "https://test.qmentisai.ai/api",
   // frontendUrl: "https://test.qmentisai.ai",
};
export default base_url;
